/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertsService } from '../../common/alerts/alerts.service';
import { Router } from '@angular/router';
import { Card, Deck } from '@deckplan.io/common';
import { CardService } from '../../cards/card.service';
import { AuthService } from '../../auth/auth.service';
import { Gtag } from 'angular-gtag';
import { filter, map } from 'rxjs/operators';
import { DecksService } from '../../decks/decks.service';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-landing',
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {

    public signUp: FormGroup;

    public deckFrontCard: Card;
    public deckSmallCards: Card[] = [];

    public publicDecks: Observable<Deck[]>;

    private firstSignUpChange = true;
    // eslint-disable-next-line no-magic-numbers
    private readonly numberOfPublicDecks = 6;

    constructor(formBuilder: FormBuilder,
                private readonly alertsService: AlertsService,
                private readonly authService: AuthService,
                private readonly cardService: CardService,
                private readonly decksService: DecksService,
                private readonly router: Router,
                private readonly gtag: Gtag) {
        this.signUp = formBuilder.group({
            alias: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]]
        });

        this.signUp.valueChanges.pipe(filter(() => this.firstSignUpChange))
            .subscribe(() => {
                this.firstSignUpChange = false;
                this.gtag.event('register_dirty', {
                    event_category: 'account'
                });
            });
    }

    public ngOnInit(): void {
        this.gtag.pageview({
            page_title: 'Landing',
            page_path: '/',
            page_location: 'https://deckplan.io/'
        });

        if (this.authService.currentUserValue) {
            this.router.navigate(['/home']);
        }

        // Fireball
        this.cardService.getCard('7220aaa0-c457-4067-b1ff-360b161c34e5').subscribe((card: Card) => this.deckFrontCard = card);

        // Retrieve the other cards in the deck display
        // Mountain
        this.cardService.getCard('70ff4fd5-c26f-4274-b899-1f995d4d8c25').subscribe((card: Card) => this.deckSmallCards.push(card));
        // Niv-Mizzet, Dracogenius
        this.cardService.getCard('1b1c4bed-9b6b-42f9-939d-ece0f959a0a3').subscribe((card: Card) => this.deckSmallCards.push(card));
        // Island
        this.cardService.getCard('fc9a66a1-367c-4035-a22e-00fab55be5a0').subscribe((card: Card) => this.deckSmallCards.push(card));
        // Lightning Blast
        this.cardService.getCard('2ca1ead8-44d8-406f-af36-276f41a47904').subscribe((card: Card) => this.deckSmallCards.push(card));
        // Counterspell
        this.cardService.getCard('cca8eb95-d071-46a4-885c-3da25b401806').subscribe((card: Card) => this.deckSmallCards.push(card));

        this.publicDecks = this.decksService.getPublic(null,
            {
                sort: {active: 'upvoteCount', direction: 'desc'},
                page: {pageSize: this.numberOfPublicDecks, pageIndex: 0}
            }
        ).pipe(map(decksWithTotalCount => decksWithTotalCount.decks));
    }

    public onSubmit() {
        const signupRouteParams = {
            alias: this.signUp.controls.alias.value,
            email: this.signUp.controls.email.value,
            isPlanner: true
        };
        this.router.navigate(['/signup', signupRouteParams]);
    }
}
